export default "__VITE_ASSET__CNpkBlWI__"